<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" >
      <div class="modal" style="width: 100%; height: 100%;">
        <header class="modal-header">
          <slot name="header">
            <v-btn
              absolute
              dark
              fab
              right
              type="button"
              class="btn-close"
              @click="close"
              color="pink"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </slot>
        </header>

        <div v-if="!newFace">

          <div v-if="Object.keys(displayFaces).length==0" style="padding-top: 50px;">
              No results
          </div>

            <v-layout justify-space-around row wrap>
            <a class="hoverenlarge" v-for="(face, faceId) in displayFaces" v-on:click="imgselected(faceId)" v-bind:key="faceId">
                <img :src="face.thumb" >
            </a>
            </v-layout>
            <v-fab-transition>
            <v-btn
                absolute
                dark
                fab
                bottom
                right
                fixed
                color="pink"
                style="bottom: 40px;"
                v-on:click="onAddFaceBtnClick()"
            >
                <v-icon>add</v-icon>
                <input id="mediacapture" ref="mediacapture" type="file" accept="image/gif;image/png;image/jpeg">
            </v-btn>

            </v-fab-transition>
          </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'modal',
  data () {
    return {
      newFace: false
    }
  },
  computed: {
    displayFaces () {
      return this.$store.getters['main/allfaces']
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    imgselected (faceId) {
      this.$emit('faceId', faceId)
      this.$emit('close')
    },
    onAddFaceBtnClick () {
      this.imageInput.click()
    },
    readPicture (e) {
      this.$emit('newFace', e)
    }
  },
  mounted: function () {
    this.imageInput = this.$refs['mediacapture']
    this.imageInput.addEventListener('change', e => this.readPicture(e))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CharacterPicker/CharacterPicker.vue